import dateToFedFormatFactory from 'tfs.front-end-utils/CSV/dateToFedFormatFactory'
import getGenderFromCSV from 'tfs.front-end-utils/CSV/getGenderFromCSV'

import ServerUploadedPassengerInterface from '../../interfaces/server/UploadedPassenger'

import { moment } from '../../utils/dates'

const dateToFedFormat = dateToFedFormatFactory(moment)

export const gender = (passenger: ServerUploadedPassengerInterface) =>
  getGenderFromCSV(passenger.infantGender)

export const dateOfBirth = (passenger: ServerUploadedPassengerInterface) =>
  dateToFedFormat(passenger.infantDateOfBirth)

export default {
  firstName: 'infantFirstName',
  lastName: 'infantLastName',
  dateOfBirth,
  gender,
}
